// extracted by mini-css-extract-plugin
export default {"container":"Versions__container-PM6HX","numberAndStatusColumn":"Versions__numberAndStatusColumn-fyhND","dash":"Versions__dash-NUNu9"};